import { useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';

import { useShell } from '../../AppShell/ShellContext';

export interface DefaultVariantProps {
  showSpace: boolean;
  maxWidth?: string;
  children: React.ReactNode;
}

/**
 * Default page variant — applies responsive gutters and sidebar-aware
 * left padding, matching the legacy PageContent styling.
 *
 * Breakpoints (MUI default spacing = 8px per unit):
 *   xs (≤599px):  showSpace ? padding 0 16px : 0
 *   sm (≥600px):  showSpace ? padding 0 36px : 0
 *   md (≥960px):  paddingLeft = drawerWidth + (showSpace ? 36px : 0)
 */
export const DefaultVariant: React.FC<DefaultVariantProps> = ({
  showSpace,
  maxWidth,
  children,
}) => {
  const { drawerWidth } = useShell();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  // Responsive padding that mirrors legacy PageContent.root
  // Sidebar offset (drawerWidth) is always applied at md+ regardless of showSpace
  // to prevent content from rendering behind the fixed sidebar.
  // The 36px gutter is only added when showSpace is true.
  const paddingRight = showSpace ? (isSmUp ? 36 : 16) : 0;
  const paddingLeft = isMdUp
    ? drawerWidth + (showSpace ? 36 : 0)
    : showSpace
      ? isSmUp
        ? 36
        : 16
      : 0;

  return (
    <div
      className="flex h-full w-full flex-col overflow-auto box-border"
      style={{
        paddingLeft,
        paddingRight,
        ...(maxWidth ? { maxWidth } : {}),
      }}
    >
      {children}
    </div>
  );
};
